module.exports = __webpack_public_path__ + "static/img/ComIntroEn.623d1a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ComIntroEn.jpg
// module id = eRlH
// module chunks = 5